import { bigPictureCta as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';
import { BigPictureCtaProps } from '.';

const TestData: BigPictureCtaProps = {
  eyebrow: 'test',
  header: 'Let’s write your next chapter together.',
  img: 'image',
  ctaText: 'Learn More',
  ctaUrl: '#',
};

export default fakeProps(schema, TestData);
